import { useState } from 'react';

export default () => {
  const initialNotifiation = { message: '', severity: 'success', opened: false };
  const [notificationState, setNotificationState] = useState(initialNotifiation);

  return {
    notificationState,
    setNotificationState,
  };
};
